/* v8 ignore start */
import {JsonModel} from "@/lib/core/jsonModel";
import {LottieShapePropertyModel} from "@/lib/lottie/animatedProperties/lottieShapePropertyModel";
import {LottieValueModel} from "@/lib/lottie/animatedProperties/lottieValueModel";

export class LottieMaskPropertyModel extends JsonModel<LottieMaskPropertyModel.IJson> {
  public adjustTimingBy(factor: number): this {
    return this.update({pt: new LottieShapePropertyModel(this.json.pt).adjustTimingBy(factor).toObject()});
  }
}

export namespace LottieMaskPropertyModel {
  /**
   * Mask Mode
   * n: "None"
   * a: "Additive"
   * s: "Subtract"
   * i: "Intersect"
   * l: "Lighten"
   * d: "Darken"
   * f: "Difference"
   */

  type TMaskMode = "n" | "a" | "s" | "i" | "l" | "d" | "f";

  export interface IJson {
    /**
     * Inverted Mask flag
     * @default false
     */
    inv?: boolean;

    /**
     * Mask name. Used for expressions and effects.
     */
    nm?: string;

    /**
     * Mask vertices
     */
    pt: LottieShapePropertyModel.TJson;

    /**
     * Mask opacity.
     * @default { a: 0, k: 100 }
     */
    o?: LottieValueModel.TJson;

    /**
     * Mask mode. Not all mask types are supported.
     * @default "a"
     */
    mode?: TMaskMode;

    /**
     * Mask expansion.
     * @default { a: 0, k: 0 }
     */
    x?: LottieValueModel.TJson;
  }
}
/* v8 ignore stop */
